import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import { getProfileRoutes } from '@client/pages/profilePage/routesProfile';
import { selectUserPermissions } from '@client/redux/user/userReducer';
import { ProfileSvg } from '@client/components/icons/profileSvg/ProfileSvg';
import { LogoutSvg } from '@client/components/icons/logoutSvg/LogoutSvg';
import { useAuth0 } from '@client/helperComponents/react-auth0-spa';
import ReactLink from '@client/components/reactLink/ReactLink';
import { trackCustomEvent } from '@client/tracking/GTM';
import {
  EVENT_GA,
  CATEGORY_NAVIGATION,
  ACTION_LINK_CLICK,
} from '@client/definitions/tracking';
import { LOGOUT, PROFILE } from '@client/definitions/constants';
import styles from './profileDropDown.scss';

const ProfileDropDown = ({ userPermissions }) => {
  const [isOpen, setIsOpen] = useState(false);
  const auth = useAuth0();
  const firstName = auth?.user?.given_name;
  const lastName = auth?.user?.family_name;

  const restrictions = Map({
    shouldBeLoggedIn: true,
    permissions: userPermissions,
  });

  const profileRoutes = getProfileRoutes(restrictions);
  const showProfileNavItem =
    profileRoutes?.ACCOUNT?.ROUTES?.PROFILE?.ROUTES?.INFORMATION;

  const createInitials = (firstName, lastName) => {
    if (firstName && lastName) {
      return `${firstName?.charAt(0)}${lastName?.charAt(0)}`;
    }

    return false;
  };

  const initials = createInitials(firstName, lastName);

  const handleLogout = (name) => {
    auth?.logout({ returnTo: process.env.REACT_APP_AUTH0_REDIRECT_URI });
    trackNavigationClick(name);
  };

  const trackNavigationClick = (name) => {
    trackCustomEvent(EVENT_GA, {
      click_category: CATEGORY_NAVIGATION,
      click_type: ACTION_LINK_CLICK,
      click_text: name,
    });
  };

  return (
    <div className={styles.container}>
      <button
        className={`${styles.button} ${isOpen ? styles.buttonOpen : ''}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        {initials ? (
          <span className={styles.initials}>{initials}</span>
        ) : (
          <ProfileSvg />
        )}
      </button>
      {isOpen && (
        <ul className={`${styles.dropDown}`} onClick={() => setIsOpen(false)}>
          {showProfileNavItem && (
            <li className={styles.dropDownItem}>
              {' '}
              <ReactLink
                className={styles?.link}
                to={'/mitt-konto/profil/mina-uppgifter/'}
                onClick={() => trackNavigationClick(PROFILE)}
              >
                {PROFILE}
              </ReactLink>
            </li>
          )}
          <li className={styles.link}>
            <button className={styles.btn} onClick={() => handleLogout(LOGOUT)}>
              <LogoutSvg />
              <span className={styles.link}>{LOGOUT}</span>
            </button>
          </li>
        </ul>
      )}
    </div>
  );
};

ProfileDropDown.propTypes = {
  pathname: PropTypes.string,
  userPermissions: ImmutablePropTypes.list,
};

function mapStateToProps(state) {
  return {
    userPermissions: selectUserPermissions(state),
  };
}
export default connect(mapStateToProps)(ProfileDropDown);
